export const RECENT_GROUP_LIMIT = 10;

/** Most recent first. A repeat click moves that workspace to the front. */
export const pushRecentGroupUuid = (
  recentGroupUuids: readonly string[],
  groupUuid: string,
): string[] =>
  [groupUuid, ...recentGroupUuids.filter((uuid) => uuid !== groupUuid)].slice(
    0,
    RECENT_GROUP_LIMIT,
  );

export const readRecentGroupUuids = (value: unknown): string[] => {
  if (!Array.isArray(value)) return [];

  const seen = new Set<string>();
  const recent: string[] = [];
  for (const uuid of value) {
    if (typeof uuid !== "string" || uuid.length === 0 || seen.has(uuid)) {
      continue;
    }
    seen.add(uuid);
    recent.push(uuid);
    if (recent.length === RECENT_GROUP_LIMIT) break;
  }
  return recent;
};
